/* NEXOWEAR · sistema de movimiento (nx-motion). Estilos en assets/nx-motion.css.
   Un solo IntersectionObserver para todo el sitio. Cada elemento entra una vez con desenfoque de movimiento
   (o fundido, en imágenes) y en cascada con sus vecinos. No toca contenido ni enlaces.
   html.nx-m lo pone sections/nx-cart-loader.liquid solo si hay IntersectionObserver y la persona no pidió
   reducir movimiento; si este archivo no carga, el mismo loader quita html.nx-m y todo se ve normal. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('nx-m')) return;
  window.NXMotion = { version: 1 };

  /* Tipo: 'b' = blur (texto y tarjetas) · 'img' = fundido · 'clip' = recorte. first = primera pantalla, entra al cargar. */
  var GROUPS = [
    /* Primera pantalla */
    { sel: '[class*="ai-adaptive-banner__heading"], [class*="ai-adaptive-banner__button"]', first: true },
    { sel: '.nx-hero__title, .nx-hero__lead, .nx-hero__tiers, .nx-hero__note', first: true },
    { sel: '.nx-info > .nx-ref, .nx-info > .nx-info__title, .nx-info > .nx-lead, .nx-info > .nx-box', first: true },
    { sel: '.nx-gallery__main', type: 'img', first: true },
    { sel: '.pg-hero-content > *', first: true },
    { sel: '.nx-404 .nx-wrap > *, .nx-noresults .nx-wrap > *', first: true },
    { sel: '.product-page-wrapper .product-images-container', type: 'img', first: true },
    { sel: '.product-page-wrapper .product-details-container', first: true },

    /* Inicio */
    { sel: '[class*="ai-services-grid__title-"]:not([class*="__title-item"]), [class*="ai-services-grid__item"]' },
    { sel: '.nx-hc__head, .nx-hc__item, .nx-hc__all, .nx-hc__actions' },
    { sel: '.logos-slider-title' },
    { sel: '[class^="ai-nw-title-"], [class^="ai-nw-feature-"]:not([class^="ai-nw-feature-title"]), [class^="ai-nw-btn-wrapper"]' },
    { sel: '.proceso-header' },
    { sel: '.imagen-con-texto-content' },
    { sel: '.imagen-con-texto-image-container', type: 'img' },
    { sel: '.banner__content' },
    { sel: '.contact-banner-wrapper .banner-column' },

    /* Catálogo y fichas */
    { sel: '.nx-toolbar, .nx-jumps, .nx-ghead, .nx-group__head, .nx-banner, .nx-perso, .nx-side' },
    { sel: '.nx-card' },
    { sel: '.nx-pdp .nx-form, .nx-pdp .nx-details, .nx-pdp .nx-h2' },
    { sel: '.nx-tiers--full .nx-tier' },

    /* Páginas de servicio, rubro, zonas y lista de precios */
    { sel: '.pg-stat, .pg-section-title, .pg-section-sub, .pg-feature-card, .pg-step, .pg-accordion-item, .pg-split-text, .pg-zone' },
    { sel: '.pg-split-visual', type: 'img' },
    { sel: '.pg-gallery-item', type: 'clip' },
    { sel: '.nxz-intro, .nxz-zone, .nxz-srv, .nxz-box, .nxz-final' },
    { sel: '.ct-step, .ct-card, .ct-cond' },

    /* Personalizados (venta a personas): títulos separadores, grillas de productos y preguntas frecuentes */
    { sel: '.separator-title, .separator-subtitle' },
    { sel: '.hoodies-lab-section .product-item, .hoodies-lab-button-wrapper' },
    { sel: '[class^="faq-section-"] > h2, [class^="faq-item-"]' },

    /* Páginas de texto (guías, política de privacidad, FFG), artículos del blog y descripción de productos */
    { sel: '.rte > h2, .rte > h3, .rte > h4, .rte > p, .rte > ul, .rte > ol, .rte > table, .rte > blockquote, .rte > figure, .pp-wrap > *, .pp-box' },

    /* Carrito y pie de página: solo fundido, sin desenfoque (ahí importa la rapidez) */
    { sel: '#main-cart-items .cart-item, .cart__footer .cart__blocks, .cart__footer .cart__ctas, .cart__empty-text', type: 'f' },
    { sel: '.footer__branding, .footer__contact-grid > *, .footer__extra, .footer__bottom', type: 'f' }
  ];
  /* Lo que ya tiene animación propia no se toca */
  var SKIP = '.pg-related-card, [class^="a1-"], [class*=" a1-"], .logos-animation-wrapper';

  var items = [];
  GROUPS.forEach(function (g) {
    var list;
    try { list = document.querySelectorAll(g.sel); } catch (e) { return; }
    Array.prototype.forEach.call(list, function (el) {
      if (el.hasAttribute('data-nx-r') || el.closest(SKIP) || el.classList.contains('scroll-trigger')) return;
      el.setAttribute('data-nx-r', g.type || 'b');
      if (g.first) el.setAttribute('data-nx-first', '');
      items.push(el);
    });
  });

  function finish(el) {
    var done = function (e) {
      if (e && e.target !== el) return;
      el.classList.add('nx-done');
      el.style.removeProperty('--nx-d');
      el.removeEventListener('transitionend', done);
    };
    el.addEventListener('transitionend', done);
    setTimeout(done, 2000);
  }
  function reveal(batch) {
    batch.sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    var step = parseInt(getComputedStyle(root).getPropertyValue('--nx-stagger'), 10) || 70;
    batch.forEach(function (el, i) {
      el.style.setProperty('--nx-d', Math.min(i, 7) * step + 'ms');
      el.classList.add('nx-in');
      finish(el);
    });
  }

  /* Primera pantalla: entra apenas carga (dos frames para que el navegador registre el estado inicial) */
  var first = items.filter(function (el) { return el.hasAttribute('data-nx-first'); });
  var rest = items.filter(function (el) { return !el.hasAttribute('data-nx-first'); });
  requestAnimationFrame(function () { requestAnimationFrame(function () { reveal(first); }); });

  /* Lo que ya está a la vista y no es de la primera pantalla queda quieto (evita parpadeos) */
  var vh = window.innerHeight || root.clientHeight;
  var pending = [];
  rest.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0 && r.height > 0) {
      el.classList.add('nx-in', 'nx-done');
    } else {
      pending.push(el);
    }
  });

  var queue = [];
  var scheduled = false;
  function enqueue(el) {
    if (el._nxQ) return;
    el._nxQ = true;
    io.unobserve(el);
    queue.push(el);
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; var b = queue; queue = []; reveal(b); });
    }
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) enqueue(e.target); });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
  pending.forEach(function (el) { io.observe(el); });

  /* Respaldo: si se salta una zona (ancla, volver atrás, scroll muy rápido), lo que ya quedó arriba también entra */
  var sweepT = null;
  function sweep() {
    sweepT = null;
    var h = window.innerHeight || root.clientHeight;
    /* Al llegar al final de la página entra también lo que quedó en el último tramo (pie de página) */
    var atEnd = (window.pageYOffset || root.scrollTop) + h >= root.scrollHeight - 4;
    pending = pending.filter(function (el) {
      if (el._nxQ) return false;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && (r.top < h * 0.92 || (atEnd && r.top < h))) { enqueue(el); return false; }
      return true;
    });
    if (!pending.length && !timelines.length) window.removeEventListener('scroll', onScroll);
    timelines.forEach(function (t) { t(h); });
  }
  function onScroll() { if (!sweepT) sweepT = setTimeout(sweep, 160); }
  var timelines = [];
  window.addEventListener('scroll', onScroll, { passive: true });

  /* «Cómo funciona»: línea de progreso que se va llenando y enciende cada paso */
  Array.prototype.forEach.call(document.querySelectorAll('.section-proceso'), function (sec) {
    var cols = sec.querySelectorAll('.proceso-column');
    var wrap = sec.querySelector('.proceso-columns');
    if (!cols.length || !wrap) return;
    var tl = document.createElement('div');
    tl.className = 'nx-tl';
    tl.setAttribute('aria-hidden', 'true');
    tl.innerHTML = '<span class="nx-tl__fill"></span>';
    var dots = [];
    for (var i = 0; i < cols.length; i++) {
      var d = document.createElement('span');
      d.className = 'nx-tl__dot';
      d.style.left = ((i + 0.5) / cols.length * 100) + '%';
      tl.appendChild(d);
      dots.push(d);
    }
    wrap.parentNode.insertBefore(tl, wrap);
    var fill = tl.firstChild;
    var on = 0;
    function light(col) {
      if (col._nxOn) return;
      col._nxOn = true;
      io2.unobserve(col);
      var idx = Array.prototype.indexOf.call(cols, col);
      setTimeout(function () {
        dots[idx].classList.add('nx-on');
        var num = col.querySelector('.proceso-step-number');
        if (num) num.classList.add('nx-on');
        on = Math.max(on, idx + 1);
        fill.style.width = (on === cols.length ? 100 : ((on - 0.5) / cols.length * 100)) + '%';
      }, 250 + idx * 90);
    }
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) light(e.target); });
    }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
    Array.prototype.forEach.call(cols, function (c) { io2.observe(c); });
    timelines.push(function (h) {
      Array.prototype.forEach.call(cols, function (c) { if (c.getBoundingClientRect().top < h * 0.85) light(c); });
    });
  });
})();
